const Ls10CasaVisitas = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <div className='container p-4'>
                        <p className='texto--parrafo pt-4'><span className="texto--span">Visitas:</span> es recomendable dosificar las visitas, sobre todo al principio, y que no toquen demasiado al beb&eacute; ni lo carguen en brazos. <span className="texto--span">Hay que tener especial cuidado con los resfriados o cualquier otro tipo de enfermedad contagiosa,</span> por lo que las personas que tengan intenci&oacute;n de visitar al beb&eacute; deben estar seguras de no padecer ni haber padecido recientemente ninguna afecci&oacute;n similar.</p>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls10Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container px-4 pt-0'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='https://www.healthychildren.org/English/safety-prevention/immunizations/Pages/Immunizations-For-Preterm-Babies.aspx'>https://www.healthychildren.org/English/safety-prevention/immunizations/Pages/Immunizations-For-Preterm-Babies.aspx</a></p>
                    </div>

                    <div className='container pt-4'>

                        <div className='container py-3'>
                            <div className='row d-flex align-items-center'>
                                <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                    <img src="./img/Ls10Mother.png" className='' />
                                </div>
                                <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                    <p className='texto--parrafo ps-lg-4 ps-xl-4'><span className="texto--span">Practicar el m&eacute;todo canguro:</span> los beb&eacute;s prematuros necesitan que los padres les brinden contacto piel a piel a trav&eacute;s de caricias y masajes. <span className="texto--span">El m&eacute;todo canguro (cargar al beb&eacute; sobre el pecho de la madre o padre en contacto piel a piel) ha demostrado ser muy ventajoso para su desarrollo.</span>
                                    Entre otros beneficios, ayuda a regular la respiraci&oacute;n y la temperatura corporal, a reducir el estr&eacute;s, a tolerar mejor el dolor, a facilitar la lactancia materna y a establecer un v&iacute;nculo emocional con los padres.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container px-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='https://www.healthychildren.org/English/ages-stages/baby/preemie/Pages/About-Skinto-Skin-Care.aspx'>https://www.healthychildren.org/English/ages-stages/baby/preemie/Pages/About-Skinto-Skin-Care.aspx</a></p>
                    </div>

                </div>

                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls10Baby.gif" className='justify-content-start style--image-baby-10' />
                </div>
            </div>
        </div>
    )
}

export default Ls10CasaVisitas;